import { Pipe, PipeTransform } from '@angular/core';

import { formatRackeoAmount } from './shared/web-hosting-pricing.util';
import { RackeoLocaleService } from './shared/services/locale.service';

@Pipe({ name: 'rackeoCurrency' })
export class RackeoCurrencyPipe implements PipeTransform {
  constructor(private readonly localeService: RackeoLocaleService) {}

  transform(value: number | null | undefined, decimals: number = 0): string {
    const content = this.localeService.getContentSnapshot();
    const locale = content?.cart?.priceLocale ?? 'es-CL';

    return formatRackeoAmount(value, locale, decimals);
  }
}